export enum CustomerAllowedIntegrationSteps {
  SelectIntegrationType = 1,
  ShowRequirements = 2,
  AddIntegration = 3,
  SuccessView = 4,
  EditIntegration = 5,
  ShowRequirementsOnEdit = 6,
}
